import React, { PropTypes } from "react";
import Component from "react-pure-render/component";
import { findDOMNode } from "react-dom";
import { DragSource, DropTarget } from "react-dnd";
import DragLayer from "./dragLayer.react";

const itemSource = {
  beginDrag(props) {
    const { setDraggingItemUID } = props;
    setDraggingItemUID(props.itemUID);
    return {
      itemUID: props.itemUID
    };
  },
  endDrag(props, monitor, component) {
    const { setDraggingItemUID, setHoveringItemUID, dropAction } = props;
    if (dropAction) {
      dropAction();
    }
    setDraggingItemUID("");
    setHoveringItemUID("");
  }
};

const itemTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().itemUID;
    const hoverIndex = props.itemUID;

    if (dragIndex === hoverIndex) {
      return;
    }

    const { setHoveringItemUID, hoveringItemUID } = props;
    setHoveringItemUID(hoverIndex);

    if (hoverIndex === hoveringItemUID) {
      return;
    }

    const { moveAction, moveActionProps } = props;
    if (moveAction) {
      moveAction(dragIndex, hoverIndex, moveActionProps);
    }
  }
};

function getTypes(props) {
  return props.types;
}

class MenuItemDragAndDrop extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    itemUID: PropTypes.string.isRequired,
    types: PropTypes.string.isRequired,
    setDraggingItemUID: PropTypes.func.isRequired,
    draggingItemUID: PropTypes.string.isRequired,
    setHoveringItemUID: PropTypes.func.isRequired,
    hoveringItemUID: PropTypes.string.isRequired,
    moveAction: PropTypes.func,
    moveActionProps: PropTypes.object,
    dropAction: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.wrapperWidth = 0;
    this.getElementWrapperWidth = this.getElementWrapperWidth.bind(this);
  }

  componentDidMount() {
    this.getElementWrapperWidth();
    window.addEventListener("resize", this.getElementWrapperWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.getElementWrapperWidth);
  }

  getElementWrapperWidth = () => {
    const { elementWrapper } = this.refs;
    this.wrapperWidth = findDOMNode(
      elementWrapper
    ).getBoundingClientRect().width;
  };

  renderLayer = () => {
    const {
      children,
      itemUID,
      draggingItemUID,
      dragLayerComponent
    } = this.props;

    if (itemUID === draggingItemUID) {
      if (dragLayerComponent) {
        return (
          <DragLayer wrapperWidth={this.wrapperWidth}>
            {dragLayerComponent}
          </DragLayer>
        );
      } else {
        return (
          <DragLayer wrapperWidth={this.wrapperWidth}>{children}</DragLayer>
        );
      }
    }
  };

  render() {
    const {
      draggingItemUID,
      itemUID,
      connectDragSource,
      connectDropTarget,
      children
    } = this.props;
    const opacity = itemUID === draggingItemUID ? 0 : 1;
    const width = "100%";

    return connectDropTarget(
      connectDragSource(
        <div style={{ width }}>
          <div style={{ opacity, width }} ref="elementWrapper">
            {children}
          </div>
          {this.renderLayer()}
        </div>
      )
    );
  }
}
export default DropTarget(getTypes, itemTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))(
  DragSource(getTypes, itemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }))(MenuItemDragAndDrop)
);



// WEBPACK FOOTER //
// ./src/browser/components/dragAndDrop.react.js